module.exports = require("./shi-Tfng.d.ts");